import { Color } from './Color';

export enum ShimmerStyles {
	BackgroundColor = Color.Neutral92,
}
